import src from "IMAGE";
export default { src, width: 323, height: 183, blurWidth: 0, blurHeight: 0};
